import React from "react";
import { Modal, Form, Select, Input, Button, message } from "antd";
import { useSelector } from "react-redux";
import { create_poc } from "../../endpoints/API";


const { Option } = Select;

function PointOfContactModal({ visible, onClose, customers,onPOCAdded  }) {
  const [form] = Form.useForm();
  const user = useSelector((state) => state.user.user);

  const onFinish = async (values) => {
  const payload = {
    ...values,
    created_by: user.user_id,
  };

  try {
    const response = await create_poc(payload);
    if (response.statusText !== "OK") {
      throw new Error("Failed to create point of contact");
    }

    const newPoc = response.data; 

    message.success("Point of contact created successfully");

    if (typeof onPOCAdded === "function") {
      onPOCAdded(newPoc);
    }

    form.resetFields();
    onClose();
  } catch (error) {
    message.error(
      error?.response?.data?.error || "Something went wrong. Please try again."
    );
  }
};

  return (
    <Modal
      title="Create Point of Contact"
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          label="Select Customer"
          name="customer"
          rules={[{ required: true, message: "Please select a customer" }]}
        >
          <Select
            placeholder="Select a customer"
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {customers?.map((customer) => (
              <Option
                key={customer.id}
                value={customer.id}
                label={`${customer.first_name} ${customer.middle_name || ""} ${customer.last_name} (${customer.email}) (${customer.phone})`}
              >
                {customer.first_name} {customer.middle_name || ""} {customer.last_name}
                <span> ({customer.email})</span>
                <span> ({customer.phone})</span>
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="First Name"
          name="first_name"
          rules={[{ required: true, message: "Please enter the first name" }]}
        >
          <Input placeholder="Enter first name" />
        </Form.Item>

        <Form.Item label="Middle Name" name="middle_name">
          <Input placeholder="Enter middle name (optional)" />
        </Form.Item>

        <Form.Item
          label="Last Name"
          name="last_name"
          rules={[{ required: true, message: "Please enter the last name" }]}
        >
          <Input placeholder="Enter last name" />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="phone"
          rules={[{ required: true, message: "Please enter the phone number" }]}
        >
          <Input type="tel" placeholder="Enter phone number" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[{ type: "email", message: "Please enter a valid email" }]}
        >
          <Input placeholder="Enter email (optional)" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default PointOfContactModal;
